import { ContactRolesEnum } from '@/bundles/Contact/enums/contactRoles';

export const contactCompanyRoles = [
  { text: 'Agent', value: ContactRolesEnum.agent },
  { text: 'Contractor', value: ContactRolesEnum.contractor },
  { text: 'Employee', value: ContactRolesEnum.employee },
];
